async function getUserConfirmation() {
  const dialog = document.querySelector('dialog')
  const cancelActionButton = dialog.querySelector('button[value="cancel"]')
  const warningActionButton = dialog.querySelector('#warning-confirm-action-button')
  const confirmActionButton = dialog.querySelector('#confirm-action-button')

  warningActionButton.classList.add('hidden')

  let userConfirms = new Promise(function (resolve) {
    cancelActionButton.addEventListener('click', () => {
      closeDialogAndResolve(resolve, dialog, false)
    })

    confirmActionButton.addEventListener('click', () => {
      closeDialogAndResolve(resolve, dialog, true)
    })
  })

  dialog.showModal()

  return await userConfirms
}

function closeDialogAndResolve(resolve, dialog, userConfirmed) {
  dialog.close()
  resolve(userConfirmed)
}

export { getUserConfirmation }
